module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "aside"
  }, [(_vm.links.length) ? _c('nav', {
    staticClass: "menu"
  }, [_c('ul', {
    staticClass: "lista"
  }, _vm._l((_vm.links), function(link, id) {
    return _c('li', {
      staticClass: "item"
    }, [(link.rota) ? _c('router-link', {
      staticClass: "link",
      attrs: {
        "to": {
          name: link.rota
        }
      }
    }, [_vm._v(_vm._s(link.texto))]) : (link.url) ? _c('a', {
      staticClass: "link",
      attrs: {
        "href": link.url,
        "target": "_blank",
        "noopener": "noopener"
      }
    }, [_vm._v(_vm._s(link.texto))]) : _vm._e()], 1)
  }), 0)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2183c0a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/components/HotsiteAside.vue
// module id = 465
// module chunks = 0